

type AttrType = {
  className?: string;
  name?: string;
  type?: string;
  defaultvalue?: string | number | boolean;
  label?: string;
  errors?: string;
  footer?: string;
  disabled?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  onchange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  options?: Array<unknown>[];
  accept?:string;
}

interface FormGroupProp {
  obj: AttrType;
  onchange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onselectchange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  textarea_change?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void; 

}


const HighLight = ({ name, footer }: AttrType) => {

  if (footer)
    return (<small
      id={`${name}_Help`}
      className="form-text text-muted"> {footer} </small>
    );

  return null;

};

const ErrorHighlight = ({ errors }: AttrType) => {

  const err_style = { display: 'block', padding: '5px 10px', borderRadius: '3px' };

  if ((errors as string).length > 0)
    return (<div className="invalid-feedback">
      <span className={'alert-danger'} style={err_style}> {errors} </span>
    </div>
    );

  return null;

};

const Label = ({ label, name, disabled, readOnly }: AttrType) => {

  type cssStyle = {
    color?: string;
  }
  const style: cssStyle = {};

  if (disabled === true || readOnly === true) {
    style.color = '#777';
  }

  return <label htmlFor={name} style={style}>{label}</label>;
};


const Input = (
  {
    name, type, label, defaultvalue, disabled, placeholder,
    readOnly, errors, accept, footer, onchange, className
  }: AttrType) => {

  if (type === 'checkbox') {

    return (<div>
      <input name={name} id={name} type={type}
        defaultChecked={defaultvalue as boolean}
        onChange={onchange} className={className}
        readOnly={readOnly}
      />
      &nbsp; &nbsp;
      <Label
        label={label as string}
        name={name as string}
        disabled={disabled}
        readOnly={readOnly}
      />  <br />

      {
        footer ? (
          <HighLight
            name={name}
            footer={footer}
          />
        ) : null
      }
      {
        errors ? <ErrorHighlight errors={errors} /> : null
      }
    </div>

    );
  }

  return (<div>
    
    {

      type=== 'file'? (
        <input name={name} id={name} type={type}
          defaultValue={defaultvalue as string}
          key={defaultvalue as string}
          onChange={onchange} className={className}
          readOnly={readOnly} placeholder={placeholder}
          accept={accept}
        />
      ) : (
        <input name={name} id={name} type={type}
          defaultValue={defaultvalue as string}
          key={defaultvalue as string}
          onChange={onchange} className={className}
          readOnly={readOnly} placeholder={placeholder}
           
        />
      )
    }

   
    {
      footer === null ? null : (
        <HighLight name={name}
          footer={footer} />
      )
    }
    {
      errors ? <ErrorHighlight errors={errors} /> : null
    }
  </div>
  );
};
 

interface SelectProp {
  name: string;
  options: Array<unknown>[];
  defaultvalue?: string | number;
  footer?: string;
  errors?: string;
  readOnly?: boolean;
  onchange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  classname?: string;

}

const Select = ({ name, defaultvalue, options, footer, readOnly, errors, classname, onchange }: SelectProp) => {

  return (<>
    <select name={name} id={name} 
      className={classname} disabled={readOnly}
      onChange={onchange}>
      {
        options.map((opt, idx) => (
          <option
            selected={opt[0] === defaultvalue}
            key={`opts-${name}-${idx}`}
            value={opt[0] as string}
          >{opt[1] as string}</option>)
        )
      }
    </select>

    {
      footer === null ? null : <HighLight name={name} footer={footer} />
    }
    {
      errors ? <ErrorHighlight errors={errors} /> : null
    }
  </>
  );
};


const FormGroup = ({ obj, onchange, onselectchange, textarea_change }: FormGroupProp) => {


  const clear_error = ({target}: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => {
    target.classList.remove('is-invalid'); 
  }

  return (
    <div className={'mb-4'} >

      {
        obj.type === 'hidden' ? null : obj.type === 'checkbox' ? null : (
          <Label
            label={obj.label}
            name={obj.name}
            disabled={obj.disabled}
            readOnly={obj.readOnly}
          />
        )
      }
      {
        obj.type === 'select' ? (
          <Select name={obj['name'] as string}
            footer={obj['footer']}
            errors={obj['errors']}
            classname={obj['className']}
            onchange={(event: React.ChangeEvent<HTMLSelectElement>)=>{
                if (onselectchange !== undefined)
                    onselectchange(event); 

                clear_error(event); 
              }
            }
            defaultvalue={obj['defaultvalue'] as string}
            readOnly={obj['readOnly'] as boolean}
            options={obj['options'] as unknown[][]} />
        ) : obj.type === 'textarea' ? (
            <textarea {...obj} 
              defaultValue={obj['defaultvalue'] as string} 
              onChange={textarea_change}></textarea>
       ) : (
          <Input {...obj} onchange={(event: React.ChangeEvent<HTMLInputElement>) =>{ 
              if (onchange !== undefined)
                onchange(event); 

              clear_error(event); }
          } />
        )
      }

    </div>
  );
};



export { Input, Select, HighLight, ErrorHighlight, Label, FormGroup };
